import React from "react";
import { connect } from "react-redux";
import { disableMyAccount } from "../../services/patient/action";
import DeleteModel from "../common/Model/deleteModel";

 class DisableAccount extends React.Component {
  constructor(props) {

    super(props)
    this.state = {
        userId :"",
      access_token: "",
      openPopUp:false,
      };
  }
 
  componentDidMount() {
    if (this.props.profileDetails) {
       let access_token = this.props.loginDetails;
      let userId = this.props.profileDetails.commonUser.userId

      this.setState({
        access_token,
        userId
       })
    }
  }

  confirmOkay = () => {
   
    var formBody = [];
    formBody.push("userId" + "=" + this.state.userId);
    formBody = formBody.join("&");

    this.props.disableMyAccount(this.state.access_token, formBody  );
  }
  closePopDel = ()=>{
   // document.body.classList.remove('modal-open');

     this.setState({
      openPopUp:false,
      
     })
  }

  openPopUpMoadl=()=>{
   // document.body.classList.add('modal-open');

    this.setState({
      openPopUp:true
    })
  }

  componentWillReceiveProps = nextProps => {
      
  };
  render() {
 
    return (
      <React.Fragment>
 
                      {/* Tab For Change Password */}
                      <div className="row tab-pane"    id="chang-pas">
                         
                          <div className="col-lg-12 col-md-12 col-sm-12 co-xs-12">

                            <h4>
                            Do you really want to disable your Account? If yes click below Disable my Account button
                                                    </h4>
                            <hr />

                          </div>

                          <div className="col-md-6">
 
                            <div className="text-right">
                            <button type="button" onClick={ this.openPopUpMoadl }  className="btnDefault">Disable My Account 
                            </button>
                          </div>
                          </div>

                         
                          <DeleteModel   text="Click OK to disable your account" status={this.state.openPopUp}    confirmOkay={this.confirmOkay} closePop={this.closePopDel}/>

                      </div>

                    


      </React.Fragment>
    )
  }
}
const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,

});

const mapDispatchToProps = dispatch => ({
  disableMyAccount : (token, payLoad) => dispatch(disableMyAccount(token, payLoad))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisableAccount);




 